import { render, staticRenderFns } from "./dialog-create-inbox.vue?vue&type=template&id=4d4f77db&scoped=true&"
import script from "./dialog-create-inbox.vue?vue&type=script&lang=js&"
export * from "./dialog-create-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4f77db",
  null
  
)

export default component.exports